import { render, staticRenderFns } from "./DashboardGropuCard.vue?vue&type=template&id=1b145280&"
import script from "./DashboardGropuCard.vue?vue&type=script&lang=js&"
export * from "./DashboardGropuCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports